/* Suprafeel · /pages/donde-estamos — finder behaviour ported from src/routes/donde-estamos-wf/DwFinder.tsx.
   Client-side filter on name + address + search keywords (case- and accent-insensitive); "Solo gama completa"
   keeps full-range pharmacies; "Usar mi ubicación" clears the filters and shows all; submit scrolls to the
   results. Results ≥768px: horizontal slider (swipe/trackpad + arrows, counter + progress bar). */
(function () {
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  function init(root) {
    if (!root || root.__sfwDe) return;
    root.__sfwDe = true;

    var inputs = [].slice.call(root.querySelectorAll('[data-sfw-de-q]'));
    var form = root.querySelector('[data-sfw-de-form]');
    var btnAll = root.querySelector('[data-sfw-de-all]');
    var btnFull = root.querySelector('[data-sfw-de-full]');
    var results = root.querySelector('#farmacias');
    var count = root.querySelector('[data-sfw-de-count]');
    var empty = root.querySelector('[data-sfw-de-empty]');
    var wrap = root.querySelector('[data-sfw-de-results]');
    var track = root.querySelector('[data-sfw-de-track]');
    var cur = root.querySelector('[data-sfw-de-cur]');
    var tot = root.querySelector('[data-sfw-de-tot]');
    var fill = root.querySelector('[data-sfw-de-fill]');
    var prev = root.querySelector('[data-sfw-de-prev]');
    var next = root.querySelector('[data-sfw-de-next]');
    var items = [].slice.call(root.querySelectorAll('[data-sfw-de-item]'));
    var one = root.getAttribute('data-one') || '';
    var many = root.getAttribute('data-many') || '';

    var query = '';
    var fullOnly = false;
    var active = 0;
    var settle = null;

    function cards() {
      return track ? [].slice.call(track.children).filter(function (c) { return !c.hidden; }) : [];
    }

    /* scroll position that shows card i (clamped: the last cards can share the end position) */
    function posOf(i) {
      var cs = cards();
      if (!cs.length || !cs[i]) return 0;
      var max = track.scrollWidth - track.clientWidth;
      return Math.max(0, Math.min(max, cs[i].offsetLeft - cs[0].offsetLeft));
    }

    function paint() {
      var n = cards().length;
      if (cur) cur.textContent = pad2(active + 1);
      if (tot) tot.textContent = pad2(n);
      if (fill) fill.style.width = (n ? ((active + 1) / n) * 100 : 0) + '%';
      if (prev) prev.disabled = active === 0;
      if (next) next.disabled = active >= n - 1;
    }

    function apply() {
      var q = norm(query);
      var n = 0;
      items.forEach(function (el) {
        var ok = (!fullOnly || el.getAttribute('data-full') === 'true') && (!q || norm(el.getAttribute('data-hay')).indexOf(q) !== -1);
        el.hidden = !ok;
        if (ok && track && el.parentNode === track) n++;
      });
      if (count) count.textContent = '/ ' + n + ' ' + (n === 1 ? one : many);
      if (empty) empty.hidden = n !== 0;
      if (wrap) wrap.hidden = n === 0;
      /* results remount in React (key change): back to the first card */
      active = 0;
      if (track) track.scrollLeft = 0;
      paint();
    }

    function scrollToResults() {
      if (results) results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    inputs.forEach(function (inp) {
      inp.addEventListener('input', function () {
        query = inp.value;
        inputs.forEach(function (o) { if (o !== inp) o.value = inp.value; });
        apply();
      });
    });
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); scrollToResults(); });
    if (btnAll) btnAll.addEventListener('click', function () {
      query = '';
      inputs.forEach(function (o) { o.value = ''; });
      fullOnly = false;
      if (btnFull) btnFull.setAttribute('aria-pressed', 'false');
      apply();
      scrollToResults();
    });
    if (btnFull) btnFull.addEventListener('click', function () {
      fullOnly = !fullOnly;
      btnFull.setAttribute('aria-pressed', fullOnly ? 'true' : 'false');
      apply();
    });

    function step(dir) {
      var n = cards().length;
      active = Math.max(0, Math.min(n - 1, active + dir));
      paint();
      track.scrollTo({ left: posOf(active), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    /* manual swipe / trackpad: once scrolling settles away from the active card, pick the nearest card */
    if (track) track.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(function () {
        var n = cards().length;
        if (!n) return;
        var x = track.scrollLeft;
        if (Math.abs(x - posOf(active)) <= 4) return;
        var max = track.scrollWidth - track.clientWidth;
        var idx = 0;
        if (max > 0 && x >= max - 2) idx = n - 1;
        else {
          var best = Infinity;
          for (var i = 0; i < n; i++) {
            var d = Math.abs(posOf(i) - x);
            if (d < best) { best = d; idx = i; }
          }
        }
        active = idx;
        paint();
      }, 140);
    }, { passive: true });

    paint();
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-sfw-de-finder]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
